'use strict';

module.exports = require('string.prototype.padstart');



//////////////////
// WEBPACK FOOTER
// ./node_modules/es7-shim/String.prototype.padStart.js
// module id = 806
// module chunks = 0